import api from "config/axios";

export const getArticleTypeList = () => api.get("/article_types");
